import React, { useState } from "react";
import { Table, Col, Container, Button, Row } from "reactstrap";

import Banner from "../../../components/Banner";
import "../../../assets/styles/career.scss";
import _ from "lodash";

const initialChosenSubjects = [{ id: "maths", subject: "Maths" }];
const initialPossibleSubjects = [
  { id: "further_maths", subject: "Further Maths" },
  { id: "physics", subject: "Physics" },
  { id: "chemistry", subject: "Chemistry" },
  { id: "psychology", subject: "Psychology" },
  { id: "economics", subject: "Economics" },
  { id: "business", subject: "Business" },
  { id: "computer_science", subject: "Computer Science" },
];

const Career = () => {
  return (
    <React.Fragment>
      <Banner
        title="나는 커서 무슨 일을 할 수 있을까?"
        subtitle="하고싶은 걸 정해보자"
        bg="banner2.jpg"
      />
    </React.Fragment>
  );
};

export default Career;
